import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { HomeOutlined } from '@ant-design/icons';
import 'react-toastify/dist/ReactToastify.css';
import { Typography, Pagination, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { Link } from 'react-router-dom';

import { handleCatchError } from 'utils/CatchHandler';
import GlobalBackButton from 'views/utilities/BackButtonGlobal';
import { checkMerchantOrBCAPI } from 'utils/API/Merchant APIs/MerchantApiCalls';
import BcConvertModal from 'views/Components/BcConvertModal';
import Spinner from 'views/Components/LoadingSinner';
import { createBenefApi } from 'utils/API/Merchant APIs/DmtApiCalls';
import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';
import { fetchBeneficiaryList, getCustomerLimit, deleteBeneficiaryApi } from 'utils/API/Merchant APIs/UpdatedAPIs/DMTUpdatedAPICalls';

// const senderno = localStorage.getItem('sendernumber');
const commonStyles = {
    m: 0
};
export default function DmtTransfer() {
    const shouldshowEsign = localStorage.getItem('shouldshowEsign');
    // const email = localStorage.getItem('email_id');
    // const uid = localStorage.getItem('id');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [search, setSearch] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const [benfDetails, setBenfDetails] = useState([]);
    const [maxLimit, setMaxLimit] = useState('');
    const [isFailed, setIsFailed] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isFailedMessage, setIsFailedMessage] = useState('');
    const [isSuccessMessage, setIsSuccessMessage] = useState('');

    // const [customerMobile, setCustomerMobile] = useState('');
    const [isDeleted, setIsDeleted] = useState(false);
    const [merchantModalOpen, setMerchantModalOpen] = useState(false);
    const [isBcConvertPending, setIsBcConvertPending] = useState(false);
    const [isCheckLoading, setIsCheckLoading] = useState(true);
    const [createLoading, setCreateLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const data = location?.state?.item || location?.state?.data;
    console.log('data', data);

    const [page, setPage] = useState(1);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [limit] = useState(10);

    const [totalCount, setTotalCount] = useState(0);

    const filteredData = location?.state?.filteredData;

    const index = location?.state?.index;
    const customerId = location?.state?.item?.id || location?.state?.data?.id;

    const senderno = data?.mobileNumber || location?.state?.search || localStorage.getItem('sendernumber');

    //API CALL FUNCTIONS STARTS HERE>>>>>>>>>>>>>>>>>>>>

    const getTransactionLimit = async () => {
        const customerMobileNo = data?.mobileNumber;
        const dmtType = 2;
        try {
            const payload = { customerMobileNo, dmtType };
            const response = await getCustomerLimit(payload);
            const maximumLimit = response?.data?.data?.sendupto;
            setMaxLimit(maximumLimit);
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
        }
    };

    const createBenefToIserveu = async (row, indexBenef) => {
        const benefname = row?.benefName;
        const benelname = row?.benefLname;
        const AccountNo = row?.benefAcc;
        const ifsc = row?.benefIfsc;
        const MobileNo = row?.benefMobile;
        const senderId = row?.id;
        const transfername = localStorage.getItem('dmtType');
        try {
            setCreateLoading(true);
            const payload = { senderno, benefname, benelname, AccountNo, ifsc, MobileNo, senderId, transfername };
            const response = await createBenefApi(payload);
            setCreateLoading(false);

            if (response?.status === 201) {
                const message = response?.data?.message;
                globalNotifyError(message);
            } else if (response?.status === 200) {
                navigate('/dmt2/dmt-transfer', { state: { data, row, filteredData, index, indexBenef, senderno } });
            } else {
                globalNotifyError('Transfer request failed, please try again.');
            }
        } catch (error) {
            globalNotifyError('Something went wrong.');
            setCreateLoading(false);
            console.log(error.message);
            handleCatchError(error);
        }
    };

    const customerDetails = async () => {
        try {
            //CHECKING FOR  MERCHANT OR BC
            if (!search) {
                setIsCheckLoading(true);
            }
            const agentid = localStorage.getItem('id');

            const payloadCheck = { agentid };
            const merchantBcCheckResponse = await checkMerchantOrBCAPI(payloadCheck);
            setIsCheckLoading(false);
            const agentType = merchantBcCheckResponse?.data?.agentType;
            const pendingStatus = merchantBcCheckResponse?.data?.isPending;
            setIsBcConvertPending(pendingStatus);

            if (agentType === 'Merchant' || pendingStatus || shouldshowEsign === 'true') {
                setMerchantModalOpen(true);

                return;
            }
            //CHECKING ENDS HERE
            if (!search) {
                setIsLoading(true);
            }
            // const payload = { uid, senderno, email, type };
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const response = await fetchBeneficiaryList(2, customerId, page, limit, search);

            if (response?.response?.status === 404) {
                globalNotifyError(response?.response?.data?.message);
            }

            const benfDetails = response?.data?.data?.result;

            setBenfDetails(Array.isArray(benfDetails) ? benfDetails : []);
            setTotalCount(response?.data?.data?.pagination?.totalCount || 0);
            getTransactionLimit();
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.log(error.message);
            handleCatchError(error);
        }
    };
    useEffect(() => {
        // if (search.length >= 3 || search.length === 0) {
        setPage(1); // Reset to first page
        // }
        // eslint-disable-next-line react-hooks/rules-of-hooks
    }, [search]);

    useEffect(() => {
        // if (search.length >= 3 || search.length === 0) {
        customerDetails(); // Call API only if valid search or clearing search
        // }
        // eslint-disable-next-line
    }, [page, search]);

    const handleBcModalClose = () => {
        setMerchantModalOpen(false);
    };
    useEffect(() => {
        if (customerId) {
            customerDetails();
        }
        // eslint-disable-next-line
    }, [customerId, page, limit, isDeleted]);

    //API CALL FUNCTIONS END HERE>>>>>>>>>>>>>>>>>>>>>

    function addbeneficiary() {
        localStorage.setItem('sendernumber', senderno);
        navigate('/moneyTransfer2/createBeneficiary', { state: { data, senderno } });
    }
    function ListBeneficiary() {
        navigate('/moneyTransfer1/listAllBeneficiary', { state: { data, senderno } });
    }
    function ListMoneyTransfer() {
        navigate('/moneyTransfer1/listMoneyTransfer', { state: { data, senderno } });
    }

    const handleTransferClick = (row, indexBenef) => {
        localStorage.setItem('sendernumber', senderno);
        if (row?.id) {
            navigate('/moneyTransfer2/moneyTransfer', { state: { data, row, filteredData, index, indexBenef, senderno, customerId } });
        } else {
            createBenefToIserveu(row, indexBenef);
        }
    };

    useEffect(() => {
        if (isFailed) {
            globalNotifyError(isFailedMessage);
        }
        if (isSuccess) {
            globalNotifySuccess(isSuccessMessage);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFailed, isSuccess]);

    //Delete Beneficiary >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

    const deleteBeneficiary = async (row) => {
        setIsFailedMessage('');
        setIsSuccessMessage('');
        setIsFailed(false);
        setIsSuccess(false);
        setIsDeleted(false);
        try {
            const payload = {
                beneMob: row?.mobileNumber,
                ifscCode: row?.ifscCode,
                accountno: row?.accountNumber,
                beneId: row?.id,
                agentId: String(2)
            };
            const response = await deleteBeneficiaryApi(payload);
            customerDetails();
            if (response?.data?.success) {
                setIsDeleted(true);
                setIsSuccess(true);
                setIsSuccessMessage(response?.data?.message);
            } else {
                setIsFailed(true);
                setIsFailedMessage(response?.data?.message);
            }
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
        }
    };

    const handleChange = (e) => {
        const input = e.target.value;
        // const capitalized = input.replace(/\b\w/g, (char) => char.toUpperCase());
        setSearch(input);
    };
    return (
        <>
            <div>
                {/* <<<<<<<Breadcrumb starts here>>>>>> */}
                <Box
                    sx={{
                        width: '100%',
                        height: 'auto',
                        backgroundColor: '#fff',
                        ...commonStyles,
                        borderRadius: 2,
                        marginBottom: 2,
                        boxShadow: 2,
                        padding: '20px 10px',
                        '@media screen and (min-width: 600px)': {
                            padding: 2
                        }
                    }}
                >
                    <Typography variant="h3">
                        <GlobalBackButton /> Domestic Money Transfer
                    </Typography>

                    <Box sx={{ marginTop: '10px' }}>
                        <Link to="/merchant-home" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <HomeOutlined />
                        </Link>

                        <Typography component="span" style={{ margin: '0 10px' }}>
                            &gt;
                        </Typography>
                        <Link to="/moneyTransfer2/viewCustomers" state={{ data }} style={{ textDecoration: 'none', color: 'inherit' }}>
                            <Typography component="span">View Customer</Typography>
                        </Link>
                    </Box>
                </Box>
                {/* <<<<<<<Breadcrumb end here>>>>>>> */}
                <TableContainer
                    component={Paper}
                    sx={{
                        boxShadow: 2
                    }}
                >
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name : {data?.customerName}</TableCell>
                                {/* {!isMobile && (
                                    <TableCell align="right">
                                        KYC: {data?.kycStatus == 0 || data?.data[0]?.kycStatus == 0 ? 'KYC Not Applied' : 'KYC Applied'}
                                    </TableCell>
                                )} */}
                                {!isMobile && <TableCell align="right">Mobile: {data?.mobileNumber}</TableCell>}
                                {!isMobile && <TableCell align="right">MONTHLY LIMIT: {maxLimit ? maxLimit : '0'}</TableCell>}
                            </TableRow>
                        </TableHead>
                    </Table>
                </TableContainer>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button color="primary" variant="contained" disableElevation sx={{ m: 2 }} onClick={() => addbeneficiary()}>
                        Add Beneficiary
                    </Button>
                    <Button color="primary" variant="contained" disableElevation sx={{ m: 2 }} onClick={() => ListBeneficiary()}>
                        List All Beneficiaries
                    </Button>
                    <Button color="primary" variant="contained" disableElevation sx={{ m: 2 }} onClick={() => ListMoneyTransfer()}>
                        List moneyTransfer
                    </Button>
                    <Stack direction="row" spacing={2} sx={{ mb: 1 }}>
                        <TextField
                            label="Search with Beneficiary Name"
                            name="mobile"
                            value={search}
                            onChange={handleChange}
                            variant="outlined"
                        />
                    </Stack>
                </div>
                <TableContainer
                    component={Paper}
                    sx={{
                        boxShadow: 2
                    }}
                >
                    <Table size={isMobile ? 'small' : 'medium'} aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Sl. No</TableCell>
                                <TableCell align="right">Beneficiary Name</TableCell>
                                <TableCell align="right">IFSC</TableCell>
                                <TableCell align="right">Account Number</TableCell>
                                <TableCell align="right">Mobile Number</TableCell>
                                <TableCell align="center"></TableCell>
                                <TableCell align="center"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {benfDetails.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        No Data Available
                                    </TableCell>
                                </TableRow>
                            ) : (
                                benfDetails.map((row, index) => (
                                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>{(page - 1) * limit + index + 1}</TableCell>
                                        <TableCell align="right">
                                            {' '}
                                            {row?.beneNamePrefix + ' ' + row?.beneficiaryFirstName + ' ' + row?.beneficiaryLastName}
                                        </TableCell>
                                        <TableCell align="right">{row.ifscCode}</TableCell>
                                        <TableCell align="right">{row.accountNumber}</TableCell>
                                        <TableCell align="right">{row.mobileNumber}</TableCell>
                                        <TableCell align="center">
                                            <LoadingButton
                                                disabled={createLoading}
                                                // loading={loadingButtonIndex === index}
                                                color="primary"
                                                variant="contained"
                                                size={isMobile ? 'small' : 'medium'}
                                                onClick={() => {
                                                    handleTransferClick(row, row.id);
                                                }}
                                            >
                                                Transfer
                                            </LoadingButton>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Button
                                                style={{ marginLeft: '10px' }}
                                                color="error"
                                                variant="contained"
                                                size={isMobile ? 'small' : 'medium'}
                                                onClick={() => {
                                                    setSelectedRow(row);
                                                    setOpenDeleteDialog(true);
                                                }}
                                            >
                                                Delete
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Pagination
                    count={Math.ceil(totalCount / limit)}
                    page={page}
                    onChange={(e, value) => setPage(value)}
                    color="primary"
                    sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}
                />
            </div>
            {merchantModalOpen && (
                <BcConvertModal
                    isOpen={merchantModalOpen}
                    handleclose={handleBcModalClose}
                    isPending={isBcConvertPending}
                    shouldshowEsign={shouldshowEsign}
                />
            )}
            <Spinner loading={isCheckLoading || isLoading} />
            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                <DialogTitle sx={{ fontSize: '1.2rem' }}>Delete Beneficiary</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ fontWeight: 500, color: 'black' }}>
                        Are you sure you want to delete this beneficiary?
                        <br />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDeleteDialog(false)} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            deleteBeneficiary(selectedRow);
                            setOpenDeleteDialog(false);
                        }}
                        color="error"
                        variant="contained"
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
